// Section colors: [dark mode, light mode]
const sections = {
  blue: ["#60A5FA", "#2563EB"],
  green: ["#4ADE80", "#16A34A"],
  amber: ["#FBBF24", "#D97706"],
  pink: ["#F472B6", "#DB2777"],
  violet: ["#A78BFA", "#7C3AED"],
  rose: ["#FB7185", "#E11D48"],
  cyan: ["#22D3EE", "#0891B2"],
  emerald: ["#34D399", "#059669"],
  orange: ["#FB923C", "#EA580C"],
};

const sectionTokens = (index) =>
  Object.entries(sections).reduce((acc, [name, colors]) => ({ ...acc, [`section-${name}`]: colors[index] }), {});

export const tokens = {
  dark: {
    bg: "#0F1014",
    surface: "#17191F",
    "surface-raised": "#1B1D24",
    border: "#24272F",
    "border-strong": "#363A45",
    text: "#ECEDF2",
    "text-soft": "#C4C7D1",
    muted: "#9095A3",
    chip: "#22252D",
    "chip-text": "#D3D6DF",
    primary: "#60A5FA",
    "primary-contrast": "#0B1220",
    "row-selected": "#172235",
    ...sectionTokens(0),
  },
  light: {
    bg: "#F4F4F1",
    surface: "#FFFFFF",
    "surface-raised": "#FAFAF8",
    border: "#E7E7E2",
    "border-strong": "#D2D2CC",
    text: "#17181C",
    "text-soft": "#3F4149",
    muted: "#686B75",
    chip: "#F1F1EE",
    "chip-text": "#3F4149",
    primary: "#2563EB",
    "primary-contrast": "#FFFFFF",
    "row-selected": "#EEF4FF",
    ...sectionTokens(1),
  },
};

const toCssVariables = (scheme) => Object.entries(scheme).reduce((acc, [name, value]) => ({ ...acc, [`--dp-${name}`]: value }), {});

// Exposed as --dp-* CSS variables so styled-components can follow the active color scheme
export const cssVariables = {
  ':root, [data-theme="dark"]': toCssVariables(tokens.dark),
  '[data-theme="light"]': toCssVariables(tokens.light),
};
